module.exports = __webpack_public_path__ + "img/error-icon.b2174d9.png";